import { z } from 'zod'

export enum ApplicationStatus {
  ACTIVE = 1,
  DEPRECATED = 2,
  REVIEW_WAITING = 10,
  REVIEW_IN_PROGRESS = 11,
  REVIEW_DECLINE = 12,
}

export const AppAvatarSchema = z.object({ url: z.string().nullable(), color: z.string() })

export const ApplicationActionSchema = z.object({
  name: z.string(),
  title: z.string(),
  description: z.string(),
})

export const ApplicationBaseSchema = z.object({
  app_id: z.number(),
  version: z.number(),
  status: z.enum(ApplicationStatus),
  title: z.string(),
  hash: z.string().nullish(),
})

export const InstalledApplicationSchema = ApplicationBaseSchema.extend({
  description: z.string().optional(),
  hasSettings: z.boolean().optional(),
  title: z.string(),
  avatar: AppAvatarSchema.nullish(),
  api_scope: z.array(z.string()),
  actions: z.array(ApplicationActionSchema.or(z.void())).optional(),
})

export type InstalledApplication = z.infer<typeof InstalledApplicationSchema>
export type AppAvatar = z.infer<typeof AppAvatarSchema>
export type ApplicationAction = z.infer<typeof ApplicationActionSchema>
export type ApplicationBase = z.infer<typeof ApplicationBaseSchema>
